export default __webpack_public_path__ + "static/media/maintenance-bg.5c9cf54b.svg";